export const mapUserFormToPayload = (data, options = {}) => {
  const { includePole = false, primaryPoleId = null } = options;

  const user = {
    adUser: data.adUser,
    profile: { profileId: data.profileId },
    license: {
      licenseTypeId: data.licenseTypeId > 0 ? data.licenseTypeId : null,
      expireDate: data.licenseExpireDate
    },
    course: { expireDate: data.courseExpireDate },
    termsAcceptedAt: data.termsAcceptedAt
  };

  if (includePole) {
    user.pole = primaryPoleId ? { id: primaryPoleId } : null;
  }

  return user;
};

